import type { ToRefs, ToRef, ComputedRef } from 'vue';

declare type ToComputedRefs<T> = {
    [K in keyof T]: ToRef<T[K]> extends Ref<infer U>
        ? ComputedRef<U>
        : ToRef<T[K]>;
};

type ClassToRefs<T> = ToRefs<State<T>> & ToComputedRefs<Getters<T>>;

export function classToRefs<T>(target: T): ClassToRefs<T> {
    return storeToRefs(target as any) as any;
}
